import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

// Lazy-loaded components
const PromptAdminDashboard = lazy(() => import('./PromptAdminDashboard'));
const PromptList = lazy(() => import('./PromptList'));
const PromptEditor = lazy(() => import('./PromptEditor'));
const CategoryManager = lazy(() => import('./CategoryManager'));
const TagManager = lazy(() => import('./TagManager'));
const PromptAdminLogin = lazy(() => import('./PromptAdminLogin'));

export default function PromptAdminRoutes() {
  const { user, loading } = useAuthStore();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader className="h-8 w-8 text-[#F98B3D] animate-spin" />
      </div>
    );
  }

  return (
    <Suspense fallback={
      <div className="flex justify-center items-center h-screen">
        <Loader className="h-8 w-8 text-[#F98B3D] animate-spin" />
      </div>
    }>
      <Routes>
        <Route path="/login" element={<PromptAdminLogin />} />
        
        {/* Protected routes */}
        <Route path="/" element={user ? <PromptAdminDashboard /> : <Navigate to="/prompt-admin/login" replace />} />
        <Route path="/prompts" element={user ? <PromptList /> : <Navigate to="/prompt-admin/login" replace />} />
        <Route path="/prompts/new" element={user ? <PromptEditor /> : <Navigate to="/prompt-admin/login" replace />} />
        <Route path="/prompts/:id" element={user ? <PromptEditor /> : <Navigate to="/prompt-admin/login" replace />} />
        <Route path="/categories" element={user ? <CategoryManager /> : <Navigate to="/prompt-admin/login" replace />} />
        <Route path="/tags" element={user ? <TagManager /> : <Navigate to="/prompt-admin/login" replace />} />
      </Routes>
    </Suspense>
  );
}